import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-upload-folder-icon',
  templateUrl: './files-upload-folder.component.html'
})
export class FilesUploadFolderComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
